import { showDebugOption } from "@/utils/logs";
import { isAndroid } from "@/utils/platform";
import { translate } from "@utils/format";

export const EMPTY_USER_BKG = (uid: any) => {
    return {
        firebaseUser: uid,
        activityType: 0,
        birthdate: "",
        breastfeeding: 'false',
        height: 0,
        weight: 0,
        measures: 0,
        allergens: [],
        diseases: [],
        goal: 1,
        gender: "male",
        menopause: 'false',
        pregnant: 'false',
        recipesTaken: [],
        foodCategoriesToAvoid: [],
        ingredientsToAvoid: [],
        preparationTime: "45",
        location: "",
        mealSchedule: [['08:00', 'breakfast',], ['10:00', 'brunch',], ['13:30', 'lunch',], ['17:00', 'snack',], ['20:30', 'dinner',]],
        workoutSchedule: [],
        presetRecipeSchedule: [],
        generalRequirements: "",
        specificRequirements: "",
        plan: "standard",
        completed: 'false',
        dietType: "standard",
        schema: "meals3",
        packs: [['aSSphoOdoKN4nLfQUjGR']],
        numDishes: 1,
    }
}

import { writable } from 'svelte/store';

export interface Option {
    value?: string | boolean;
    text?: string;
    name?: string;
    id?: string;
}
export interface OptionWithId {
    id: string;
    name?: string;
}

export let GENDER_OPTIONS = writable<Option[]>([]);
export let ACTIVITY_OPTIONS = writable<Option[]>([]);
export let GOAL_OPTIONS = writable<Option[]>([]);
export let ALLERGEN_OPTIONS = writable<Option[]>([]);
export let DISEASES_OPTIONS = writable<Option[]>([]);
export let CATEGORIES_OPTIONS = writable<Option[]>([]);
export let PREPARATION_TIME_OPTIONS = writable<Option[]>([]);
export let MEASURE_SYSTEM_OPTIONS = writable<Option[]>([]);
export let PREGNANT_OPTIONS = writable<Option[]>([]);
export let BREASTFEEDING_OPTIONS = writable<Option[]>([]);
export let MENOPAUSE_OPTIONS = writable<Option[]>([]);
export let NUM_DISHES_OPTIONS = writable<Option[]>([]);
export let NAV_NUTRITIONAL_PROFILE = writable<Option[]>([]);
export let TRAININGS = writable<OptionWithId[]>([]);
export let MEAL_SCHEDULE = writable<OptionWithId[]>([]);

export async function loadOptions() {


    GENDER_OPTIONS.set([
        { value: 'female', text: translate('LANG_FEMALE', 'Female') },
        { value: 'male', text: translate('LANG_MALE', 'Male') },
        { value: 'none', text: translate('LANG_OTHER', 'Other') },
    ]);

    ACTIVITY_OPTIONS.set([
        { value: "0", text: translate('LANG_SEDENTARY', 'Sedentary') },
        { value: "1", text: translate('LANG_LOW', 'Low activity') },
        { value: "2", text: translate('LANG_MEDIUM', 'Medium activity') },
        { value: "3", text: translate('LANG_HIGH', 'High activity') },
    ]);

    GOAL_OPTIONS.set([
        { value: "0", text: translate('LANG_KEEP', 'Maintain weight') },
        { value: "1", text: translate('LANG_LIFESTYLE', 'Healthy lifestyle') },
        { value: "2", text: translate('LANG_LOSE', 'Lose weight') },
        { value: "3", text: translate('LANG_CUT', 'Cutting') },
        { value: "4", text: translate('LANG_GAIN_MASS', 'Gain muscle mass') },
        { value: "5", text: translate('LANG_GAIN_WEIGHT', 'Gain weight') },
    ]);

    ALLERGEN_OPTIONS.set([
        { value: "99", text: translate('LANG_OTHER_ALLERGEN', 'Others') },
        { value: "1", text: translate('LANG_NUTS', 'Nuts') },
        { value: "2", text: translate('LANG_CELERY', 'Celery') },
        { value: "3", text: translate('LANG_MUSTARD', 'Mustard') },
        { value: "4", text: translate('LANG_SESAME', 'Sesame') },
        { value: "5", text: translate('LANG_SULFITES', 'Sulfites') },
        { value: "6", text: translate('LANG_LUPINE', 'Lupine') },
        { value: "7", text: translate('LANG_MOLLUSKS', 'Mollusks') },
        { value: "8", text: translate('LANG_GLUTEN', 'Gluten') },
        { value: "9", text: translate('LANG_CRUSTACEANS', 'Crustaceans') },
        { value: "10", text: translate('LANG_EGGS', 'Eggs') },
        { value: "11", text: translate('LANG_FISH', 'Fish') },
        { value: "12", text: translate('LANG_PEANUTS', 'Peanuts') },
        { value: "13", text: translate('LANG_SOY', 'Soy') },
        { value: "14", text: translate('LANG_MILK', 'Milk') },
    ]);

    DISEASES_OPTIONS.set([
        { value: "3", text: translate('LANG_PREDIABETES', 'Prediabetes') },
        { value: "4", text: translate('LANG_OSTEOPOROSIS', 'Osteoporosis') },
        { value: "5", text: translate('LANG_HYPERTENSION', 'Hypertension') },
        { value: "6", text: translate('LANG_HYPERCHOLESTEROLEMIA', 'Hypercholesterolemia') },
        { value: "7", text: translate('LANG_HYPERTRIGLYCERIDEMIA', 'Hypertriglyceridemia') },
        { value: "8", text: translate('LANG_HIGH_URIC_ACID', 'High uric acid') },
        { value: "9", text: translate('LANG_KIDNEY_STONES', 'Kidney stones') },
        { value: "11", text: translate('LANG_MIGRAINE', 'Migraine') },
        { value: "12", text: translate('LANG_SIBO', 'SIBO') },
        { value: "14", text: translate('LANG_IBS', 'IBS') },
        { value: "15", text: translate('LANG_ARTHRITIS', 'Arthritis') },
    ]);

    CATEGORIES_OPTIONS.set([
        { value: '', text: '---', name: '---', id: '' },
        { value: '21', text: translate('LANG_CEREALS', 'Cereals'), name: translate('LANG_CEREALS', 'Cereals'), id: '21' },
        { value: '22', text: translate('LANG_CEREALS_FREE_GLUTEN', 'Gluten-free cereals'), name: translate('LANG_CEREALS_FREE_GLUTEN', 'Gluten-free cereals'), id: '22' },
        { value: '14', text: translate('LANG_LACTICS', 'Lactic products'), name: translate('LANG_LACTICS', 'Lactic products'), id: '14' },
        { value: '24', text: translate('LANG_CHEESE', 'Cheese'), name: translate('LANG_CHEESE', 'Cheese'), id: '24' },
        { value: '25', text: translate('LANG_FRUITS', 'Fruits'), name: translate('LANG_FRUITS', 'Fruits'), id: '25' },
        { value: '26', text: translate('LANG_VEGETABLES', 'Vegetables'), name: translate('LANG_VEGETABLES', 'Vegetables'), id: '26' },
        { value: '27', text: translate('LANG_TUBERS', 'Tubers'), name: translate('LANG_TUBERS', 'Tubers'), id: '27' },
        { value: '28', text: translate('LANG_LEGUMS', 'Legumes'), name: translate('LANG_LEGUMS', 'Legumes'), id: '28' },
        { value: '29', text: translate('LANG_OIL', 'Oil'), name: translate('LANG_OIL', 'Oil'), id: '29' },
        { value: '30', text: translate('LANG_PEANUTS', 'Peanuts'), name: translate('LANG_PEANUTS', 'Peanuts'), id: '30' },
        { value: '31', text: translate('LANG_RED_MEAT', 'Red meat'), name: translate('LANG_RED_MEAT', 'Red meat'), id: '31' },
        { value: '32', text: translate('LANG_LEAN_MEAT', 'Lean meat'), name: translate('LANG_LEAN_MEAT', 'Lean meat'), id: '32' },
        { value: '11', text: translate('LANG_FISH', 'Fish'), name: translate('LANG_FISH', 'Fish'), id: '11' },
        { value: '41', text: translate('LANG_WHITE_FISH', 'White fish'), name: translate('LANG_WHITE_FISH', 'White fish'), id: '41' },
        { value: '42', text: translate('LANG_BLUE_FISH', 'Blue fish'), name: translate('LANG_BLUE_FISH', 'Blue fish'), id: '42' },
        { value: '36', text: translate('LANG_CANN_FISH', 'Canned fish'), name: translate('LANG_CANN_FISH', 'Canned fish'), id: '36' },
        { value: '37', text: translate('LANG_SEAWEED', 'Seaweed'), name: translate('LANG_SEAWEED', 'Seaweed'), id: '37' },
        { value: '40', text: translate('LANG_PIG', 'Pork'), name: translate('LANG_PIG', 'Pork'), id: '40' },
        { value: '33', text: translate('LANG_JUICES', 'Juices'), name: translate('LANG_JUICES', 'Juices'), id: '33' },
        { value: '34', text: translate('LANG_SEEDS', 'Seeds'), name: translate('LANG_SEEDS', 'Seeds'), id: '34' },
        { value: '35', text: translate('LANG_PICKLES', 'Pickles'), name: translate('LANG_PICKLES', 'Pickles'), id: '35' },
        { value: '39', text: translate('LANG_CANN', 'Canned products'), name: translate('LANG_CANN', 'Canned products'), id: '39' },
        { value: '38', text: translate('LANG_ALCOHOL', 'Alcohol'), name: translate('LANG_ALCOHOL', 'Alcohol'), id: '38' },
        { value: '7', text: translate('LANG_CRUSTACEANS', 'Crustaceans'), name: translate('LANG_CRUSTACEANS', 'Crustaceans'), id: '7' },
        { value: '8', text: translate('LANG_GLUTEN', 'Gluten'), name: translate('LANG_GLUTEN', 'Gluten'), id: '8' },
        { value: '9', text: translate('LANG_MOLLUSK', 'Mollusks'), name: translate('LANG_MOLLUSK', 'Mollusks'), id: '9' },
        { value: '10', text: translate('LANG_EGGS', 'Eggs'), name: translate('LANG_EGGS', 'Eggs'), id: '10' },
        { value: '43', text: translate('LANG_FREE_GLUTEN', 'Gluten-free'), name: translate('LANG_FREE_GLUTEN', 'Gluten-free'), id: '43' },
        { value: '44', text: translate('LANG_VEGAN', 'Vegan'), name: translate('LANG_VEGAN', 'Vegan'), id: '44' },
    ]);

    PREPARATION_TIME_OPTIONS.set([
        { value: "15", text: translate('LANG_15_MINUTES', '15 minutes') },
        { value: "30", text: translate('LANG_30_MINUTES', '30 minutes') },
        { value: "45", text: translate('LANG_45_MINUTES', '45 minutes') },
        { value: "60", text: translate('LANG_1_HOUR', '1 hour') },
        { value: "90", text: translate('LANG_1_HOUR_30_MINUTES', '1 hour 30 minutes') },
        { value: "120", text: translate('LANG_2_HOURS', '2 hours') },
    ]);

    MEASURE_SYSTEM_OPTIONS.set([
        { value: "0", text: translate('LANG_METRIC', 'Metric') },
        { value: "1", text: translate('LANG_IMPERIAL', 'Imperial') },
    ]);

    PREGNANT_OPTIONS.set([
        { value: false, text: translate('LANG_NOT_PREGNANT', 'Not pregnant') },
        { value: true, text: translate('LANG_PREGNANT', 'Pregnant') },
    ]);

    BREASTFEEDING_OPTIONS.set([
        { value: false, text: translate('LANG_NOT_BREASTFEEDING', 'Not breastfeeding') },
        { value: true, text: translate('LANG_BREASTFEEDING', 'Breastfeeding') },
    ]);

    MENOPAUSE_OPTIONS.set([
        { value: false, text: translate('LANG_NO_MENOPAUSE', 'No menopause') },
        { value: true, text: translate('LANG_IN_MENOPAUSE', 'In menopause') },
    ]);

    NUM_DISHES_OPTIONS.set([
        { value: "1", text: translate('LANG_1_DISH', '1 dish') },
        { value: "2", text: translate('LANG_2_DISHES', '2 dishes') },
    ]);

    NAV_NUTRITIONAL_PROFILE.set([
        // { id: 'profile', text: translate('LANG_PROFILE', 'Profile') },
        // { id: 'diet', text: translate('LANG_DIET', 'Diet') },
        // { id: 'activity', text: translate('LANG_ACTIVITY', 'Activity') },
    ]);

    TRAININGS.set([
        { id: 'strength', name: translate('LANG_STRENGTH', 'Strength') },
        { id: 'run', name: translate('LANG_RUN', 'Run') },
        { id: 'walk', name: translate('LANG_WALK', 'Walk') },
        { id: 'hiit', name: translate('LANG_HIIT', 'HIIT') },
        { id: 'cardiovascular', name: translate('LANG_CARDIOVASCULAR', 'Cardiovascular') },
        { id: 'cycling', name: translate('LANG_CYCLING', 'Cycling') },
        { id: 'multifunctional', name: translate('LANG_MULTIFUNCTIONAL', 'Multifunctional') },
    ]);

    MEAL_SCHEDULE.set([
        { id: 'breakfast', name: translate('LANG_BREAKFAST', 'Breakfast') },
        { id: 'brunch', name: translate('LANG_BRUNCH', 'Brunch') },
        { id: 'lunch', name: translate('LANG_LUNCH', 'Lunch') },
        { id: 'snack', name: translate('LANG_SNACK', 'Snack') },
        { id: 'dinner', name: translate('LANG_DINNER', 'Dinner') },
    ]);
}

export const DAYS = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
];

export const BACKGROUND_DATA_LIST = ["allergens", "diseases", "foodCategoriesToAvoid", "ingredientsToAvoid", "workoutSchedule"];


export async function loadSettingsSections() {
    return [
        {
            items: [
                { icon: "user-circle", text: translate("USER_PROFILE", "User profile"), link: "/userProfile" },
                { icon: "apple-alt", text: translate("NUTRITIONAL_PROFILE", "Nutritional profile"), link: "/nutritionalProfile" },
                { icon: "clipboard-list", text: translate("NUTRITIONAL_PROFILE_QUESTIONAIRE", "Run questionaire again"), action: "runQuestionaireAgain" },
            ]
        },
        ...(isAndroid()
            ? [{
                title: translate("HEALTH_PERMISSIONS", "Health & Permissions"),
                items: [
                    {
                        icon: "fas fa-mobile",
                        text: translate("INSTALL_HEALTH_CONNECT", "Install Health Connect"),
                        action: "getHealthConnectFromStore"
                    },
                    // {
                    //     icon: "fas fa-user-shield",
                    //     text: translate("VIEW_HEALTH_POLICY", "View Health privacy policy"),
                    //     action: "launchPrivacyPolicy"
                    // },
                    {
                        icon: "fas fa-heartbeat",
                        text: translate("OPEN_HEALTH_SETTINGS", "Open health settings"),
                        action: "openHealthSettings"
                    }
                ]
            }] : [{
                title: translate("HEALTH_PERMISSIONS", "Health & Permissions"),
                items: [
                    {
                        icon: "fas fa-heartbeat",
                        text: translate("OPEN_HEALTH_SETTINGS", "Open health settings"),
                        action: "openHealthSettings"
                    }
                ]
            }]
        ),
        {
            items: [
                { icon: "fas fa-user", text: translate("ABOUT_US", "About us"), link: "/frame/becf2710b0c72aff8a8fb70703f53a0d712c84165d1a69156e1333f8424c2985" },
                { icon: "fas fa-dna", text: translate("SCIENCE", "Science and references"), link: "/frame/826df92157b54ce10a169a5d5d535b5cade1e47b8c1e4b5800fbd6654aec0d21" },
                { icon: "fas fa-file-alt", text: translate("TERMS", "Terms and conditions"), link: "/frame/5b42010df205d64f07801a19259d06381374d00e4fb355767cc48b9747124ede" },
                { icon: "fas fa-lock", text: translate("PRIVACY", "Private policy"), link: "/frame/0552c875423037d7c97c0dcf938b67bba844710edbca1297b2c59fb318e98904" },
                { icon: "fas fa-envelope", text: translate("CONTACT", "Contact us"), link: "/frame/46e0753bdaeda56e2b57383c1fab546d7a3d119d41d518c228c3f7e56b73cc29" },
            ]
        },
        {
            items: showDebugOption ? [
                { icon: "fas fa-sliders-h", text: translate("CONFIGURATION", "Configuration"), link: "/config" },
                { icon: "fas fa-file-alt", text: translate("LOG_VIEW", "View debug log"), link: "/logViewer" },
                {
                    icon: "sign-out",
                    text: translate("LOGOUT", "Log out"),
                    link: "/logout",
                    color: "red",
                    confirm: true,
                    confirmMessage: { message: translate("LOGOUT_CONFIRM", "Are you sure you want to log out?"), buttonOk: translate("LOGOUT", "Log out"), buttonCancel: translate("CANCEL", "Cancel") },
                },
            ] : [
                { icon: "fas fa-sliders-h", text: translate("CONFIGURATION", "Configuration"), link: "/config" },
                {
                    icon: "sign-out",
                    text: translate("LOGOUT", "Log out"),
                    link: "/logout",
                    color: "red",
                    confirm: true,
                    confirmMessage: { message: translate("LOGOUT_CONFIRM", "Are you sure you want to log out?"), buttonOk: translate("LOGOUT", "Log out"), buttonCancel: translate("CANCEL", "Cancel") },
                },
            ],
        },
    ];
}


export const EXERCISE_TYPE = [
    { value: "cardio", label: "Cardio" },
    { value: "fuerza", label: "Fuerza" },
    { value: "yoga", label: "Yoga" },
    { value: "hiit", label: "HIIT" },
];


export const ICON_MACROS = {
    kcal: "burn",
    carbs: "wheat",
    proteins: "drumstick-bite",
    fat: "bacon",
}


export function getNoDataHistory() {
    return {
        icon: "fa-salad",
        title: translate("NO_DATA_TITLE", "No data"),
        description: translate(
            "NO_DATA_DESCRIPTION",
            "You haven't added any data yet. Click + button to start tracking."
        ),
    };
}

export function getCONTEXT_MENU_MEALCARD() {
    return [
        {
            id: "edit",
            text: translate("EDIT", "View/Edit"),
            icon: "fa-edit",
        },
        {
            id: "duplicate",
            text: translate("DUPLICATE", "Duplicate"),
            icon: "fa-copy",
        },
        {
            id: "delete",
            text: translate("DELETE", "Delete"),
            icon: "fa-trash",
            color: "red",
        }
    ];
}

export function CONTEXT_MENU_RECOMMENDED_RECIPE() {
    return [
        {
            id: "add",
            text: translate("ADD_TO_HISTORY", "Add to history"),
            icon: "fa-plus",
        }
    ];
}

export const NO_DATA_NOTIFICATIONS = {
    icon: "fa-empty-set",
    title: translate("NO_DATA_NOTIFICATIONS", "No data"),
    description: translate(
        "NO_DATA_NOTIFICATIONS_DESCRIPTION",
        "You don't have any notifications yet."
    ),
}
export function getNoDataNotifications() {
    return {
        icon: "fa-empty-set",
        title: translate("NO_DATA_NOTIFICATIONS", "No hay notificaciones"),
        description: translate(
            "NO_DATA_NOTIFICATIONS_DESCRIPTION",
            "Todavía no tienes ninguna notificación."
        ),
    };
}